import { isClientLoggingOut, kickOut } from "Services/AuthService";
import { getLogger } from "Services/LoggingService";

const logger = getLogger("NetworkUtilService");

export function isUnauthenticatedResponse(statusCode: number): boolean {
    return statusCode === 403 || statusCode === 401;
}

/**
 * This callback verifies if a response is unauthorized and kicks the user out if it is.
 */
export const interceptUnauthorizedResponses = async (response: Response) => {
    if (isUnauthenticatedResponse(response.status) && !isClientLoggingOut()) {
        logger.log("Request returned unauthenticated status code, kicking user to login", {
            statusCode: response.status,
        });
        await kickOut();
    }
    return response;
};
